const lbaHotel = angular.module('app.lbaHotel', [
  require('../lbaFileDownloader').name
]);

lbaHotel.controller('lbaHotelCtrl', require('./lbaHotelCtrl'));
lbaHotel.directive('lbaHotel', require('./lbaHotelDir'));

export default lbaHotel;



// WEBPACK FOOTER //
// ./src/components/lbaHotel/index.js